<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 44 32"
  >
    <g fill="none" fill-rule="evenodd">
      <path :fill="color" d="M15 17h14v-2H15z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: "st-icon",
  props: {
    color: {
      type: String,
      default: "#6E6054",
    },
    size: {
      type: Number,
      default: 24,
    },
  },
};
</script>
